import React from 'react'
import {ApolloProvider} from '@apollo/client'
import Head from 'next/head'
import {GlobalStyles} from 'twin.macro'
import {useApollo} from '../apollo/client'
import Banner from '../components/Banner'
// import SiteLayout from '../components/SiteLayout'
import SiteLayout from '../components/layouts/FullLayout'
import {useRouter} from 'next/router'
import theme from "../components/theme/theme"
import { ThemeProvider } from "@mui/material/styles";
import '../styles/globals.css'
import '../lib/fontawesome'
const App = ({Component, pageProps}) => {
  const router = useRouter()
  const apolloClient = useApollo(pageProps)
  const getLayout =
    Component.getLayout ||
    (page => <SiteLayout>{page}</SiteLayout>)

  return (
    <>
      <Head>
        <title>Universal Admin Portal</title>
      </Head>

      <GlobalStyles />
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          {getLayout(<Component {...pageProps} />)}
        </ThemeProvider>
      </ApolloProvider>
    </>
  )
}

export default App
